import { render, staticRenderFns } from "./UploadProfilePic.vue?vue&type=template&id=b72aed28&scoped=true"
import script from "./UploadProfilePic.vue?vue&type=script&lang=js"
export * from "./UploadProfilePic.vue?vue&type=script&lang=js"
import style0 from "./UploadProfilePic.vue?vue&type=style&index=0&id=b72aed28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72aed28",
  null
  
)

export default component.exports